import styled from 'styled-components'

import { CopyButton, Truncate } from '@root/shared/ui-kit'

import type { Address } from '@root/entities/address/Address'
import type { ClassNameProps } from '@root/shared/react'

type WalletAddressTruncatedProps = {
  walletAddress: Address
  withCopy?: boolean
  copySize?: number
  withTooltip?: boolean
} & ClassNameProps

export const WalletAddressTruncated: React.FC<WalletAddressTruncatedProps> = ({
  walletAddress,
  className,
  withCopy = false,
  copySize = 16,
  withTooltip,
}) => {
  // Wallet addresses might be masked for other users (incognito mode)
  const isMasked = walletAddress.includes('…')

  const addressContent = isMasked ? (
    walletAddress
  ) : (
    <Truncate start={4} end={4}>
      {walletAddress}
    </Truncate>
  )

  if (!withCopy && !className) {
    return addressContent
  }

  return (
    <Root className={className}>
      <AddressLabel>{addressContent}</AddressLabel>
      {withCopy && !isMasked ? (
        <Copy size={copySize} value={walletAddress} withTooltip={withTooltip} />
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 3px;
  align-items: center;
`

const AddressLabel = styled.div`
  color: inherit;
  font: inherit;
`

const Copy = styled(CopyButton)`
  color: inherit;
`
